import { createReducer, on } from '@ngrx/store';
import { InHospitalListItem } from 'src/app/types/aggregate-graph/in-hospital-list/aggregate-graph.types';
import { clearStateRequested } from '../auth/auth.actions';
import * as inHospitalListGraphActions from './in-hospital-list-graph.actions';

export interface State {
	isGenerated: boolean;
	timeSlots: string[];
	items: InHospitalListItem[];
	sortAscending: boolean;
}

export const initialState: State = {
	isGenerated: false,
	timeSlots: [],
	items: [],
	sortAscending: true
}

export const inHospitalListGraphReducer = createReducer(
	initialState,
	on(inHospitalListGraphActions.inHospitalListGenerated, (state, { list }) => ({
		...state,
		isGenerated: true,
		timeSlots: list.timeSlots,
		items: list.items
	})),
	on(inHospitalListGraphActions.inHospitalListItemAdded, (state, { item }) => {
		if (!state.isGenerated) return { ...state };
		return {
			...state,
			// to guard against the server accidentally sending Added instead of Changed, filter out a potential existing item (avoids duplicate entries)
			items: state.items.filter(i => i.sheetId !== item.sheetId).concat(item)
		};
	}),
	on(inHospitalListGraphActions.inHospitalListItemChanged, (state, { item }) => {
		if (!state.isGenerated) return { ...state };
		return {
			...state,
			items: state.items.filter(i => i.sheetId !== item.sheetId).concat(item)
		};
	}),
	on(inHospitalListGraphActions.inHospitalListItemRemoved, (state, { sheetId }) => {
		if (!state.isGenerated) return { ...state };
		return {
			...state,
			items: state.items.filter(i => i.sheetId !== sheetId)
		};
	}),
	on(inHospitalListGraphActions.inHospitalListSortDirectionChanged, (state) => ({
		...state,
		sortAscending: !state.sortAscending
	})),
	on(clearStateRequested, () => initialState)
);